import React, { useRef, useState } from 'react';
import { BoxInput, InputLoginStyle, PasswordIcon } from './style';

function InputLogin({
  name,
  type = 'text',
  disabled = false,
  placeholder,
  pathIcon,
  onInputChange,
  value = '',
  reference = null,
}) {
  const inputRef = useRef(reference);
  const [typePassword, setTypePassword] = useState(type);
  const [iconPassword, setIconPassword] = useState('/images/icons/hide.svg');

  const handleChange = () => {
    const value = inputRef.current.value;

    if (onInputChange) {
      onInputChange(value);
    }
  };

  const showOrHidePassword = () => {
    if (typePassword === 'password') {
      setTypePassword('text');
      setIconPassword('/images/icons/show.svg');
    } else if (typePassword === 'text') {
      setTypePassword('password');
      setIconPassword('/images/icons/hide.svg');
    }
  };

  return (
    <InputLoginStyle>
      <img src={pathIcon} alt="user icon" />
      <BoxInput>
        <label>{name}:</label>
        <input
          type={typePassword}
          name={name}
          id={name}
          disabled={disabled}
          ref={inputRef}
          onChange={handleChange}
          placeholder={placeholder}
          defaultValue={value}
        />
        {(type === 'password') | (type === 'text') ? (
          <PasswordIcon src={iconPassword} alt="mostrar senha" onClick={showOrHidePassword} />
        ) : (
          ''
        )}
      </BoxInput>
    </InputLoginStyle>
  );
}
export default InputLogin;
